/* unplugin-vue-components disabled */import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "navbar"
};
const _hoisted_2 = {
  class: "top_title"
};
const _hoisted_3 = {
  class: "topBox"
};
const _hoisted_4 = {
  class: "timeBox"
};
const _hoisted_5 = {
  class: "timetext"
};
const _hoisted_6 = {
  class: "right-menu"
};
const _hoisted_7 = {
  class: "avatar-container"
};
const _hoisted_8 = {
  class: "avatar-wrapper"
};
const _hoisted_9 = {
  class: "user-avatar"
};
import mqtt from "precompiled-mqtt";
import { ElMessageBox } from 'element-plus';
import useUserStore from '@/store/modules/user';
import usePermissionStore from "@/store/modules/permission";
import { getUserProfile, reportMeOnline } from "@/api/system/user";
export default {
  __name: 'Navbar',
  emits: ['setLayout'],
  setup(__props, {
    emit: __emit
  }) {
    const permission = usePermissionStore();
    const {
      proxy
    } = getCurrentInstance();
    let a = Date.now();
    const client = mqtt.connect("wss://satwide.com/mqtt", {
      clientId: 'navbar' + a
    });
    let downloadQueued = [];
    let lastDownloadTime = 0;
    const timeText = ref("");
    const userStore = useUserStore();
    const state = reactive({
      user: {}
    });
    client.on("connect", () => {
      console.log(`mqtt连接成功`);
      client.subscribe([userStore.token, "task_download_"], {
        qos: 2
      }, () => {
        console.log(`订阅了token消息 ${userStore.token}`);
      });
    });
    client.on("message", (topic, message) => {
      if ("task_download_" === topic) {
        console.log(permission.downloadMp4Ready);
        console.log(permission.downloadMp4);
        console.log("收到下载完成消息:" + message.toString());
        let downloads = permission.downloadMp4;
        let downloadReadies = permission.downloadMp4Ready;
        let taskMsg = JSON.parse(message.toString());
        if (downloads.indexOf(taskMsg.taskName) !== -1) {
          const baseUrl = 'https://satwide.com/mp4download/' + taskMsg.taskName + '.mp4';
          let index = downloads.indexOf(taskMsg.taskName);
          let removedItems = downloads.splice(index, 1);
          console.log("删除的元素");
          console.log(removedItems);
          permission.setDownloadMp4(downloads);
          if (downloadReadies.indexOf(removedItems[0]) === -1) {
            downloadReadies.push(removedItems[0]);
            permission.setDownloadMp4Ready(downloadReadies);
            console.log(permission.downloadMp4Ready);
            console.log(permission.downloadMp4);
          }
          if (Date.now() - lastDownloadTime > 5) {
            lastDownloadTime = Date.now();
            downloadFile(baseUrl);
          } else {
            downloadQueued.unshift(baseUrl);
          }
        }
      } else {
        console.log("用户接收到系统账户消息");
        console.log(topic);
        console.log(message.toString());
        let userMsg = JSON.parse(message.toString());
        if (userMsg.msgCode !== 200) {
          proxy.$modal.confirmX(userMsg.msg, "系统通知", {
            showClose: false
          }).then(() => {
            userStore.logOut().then(() => {
              location.href = '/index';
            });
          }).catch(() => {
            userStore.logOut().then(() => {
              location.href = '/index';
            });
          });
        } else {
          proxy.$modal.notify(userMsg.msg);
        }
      }
    });
    function downloadFile(url) {
      return new Promise((resolve, reject) => {
        const a = document.createElement('a');
        a.href = url;
        a.download = url.split('/').pop(); // 提取文件名作为下载的文件名
        a.style.display = 'none'; // 隐藏元素
        document.body.appendChild(a); // 将元素添加到body中

        // 模拟点击后移除元素，并使用setTimeout确保点击事件被处理
        a.onclick = function () {
          document.body.removeChild(a); // 下载开始后从body中移除元素
          resolve(); // 下载开始，解决Promise
        };
        a.click(); // 模拟点击
      });
    }
    function getUser() {
      getUserProfile().then(response => {
        state.user = response.data;
      });
    }
    function meOnline() {
      if (downloadQueued.length > 0) {
        if (Date.now() - lastDownloadTime > 5) {
          let url = downloadQueued.pop();
          downloadFile(url);
        }
      }
      reportMeOnline().then(respone => {
        console.log(respone);
      });
    }
    function handleCommand(command) {
      switch (command) {
        case "setLayout":
          setLayout();
          break;
        case "logout":
          logout();
          break;
        default:
          break;
      }
    }
    function logout() {
      ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userStore.logOut().then(() => {
          location.href = '/index';
        });
      }).catch(() => {});
    }
    const emits = __emit;
    function setLayout() {
      emits('setLayout');
    }
    function getZero(num) {
      if (parseInt(num) < 10) {
        num = '0' + num;
      }
      return num;
    }
    let timer;
    let timer1;
    onMounted(() => {
      timer = setInterval(e => {
        const vWeek = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const vWeek_s = date.getDay();
        timeText.value = year + "/" + getZero(month) + "/" + getZero(day) + "\t" + vWeek[vWeek_s] + "\t" + getZero(hours) + ":" + getZero(minutes) + ":" + getZero(seconds);
      }, 1000);
      //页面打开的情况下，账户不会退出，调用一个方法去刷新token
      timer1 = setInterval(meOnline, 5000);
    });
    getUser();
    onUnmounted(() => {
      clearInterval(timer);
      clearInterval(timer1);
    });
    return (_ctx, _cache) => {
      const _component_caret_bottom = _resolveComponent("caret-bottom");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_unref(timeText)), 1)])]), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "centerBox"
      }, [_createElementVNode("div", {
        class: "centerText"
      }, [_createElementVNode("span", null, "时空数据服务SatWide")])], -1))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_dropdown, {
        onCommand: handleCommand,
        class: "right-menu-item hover-effect",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: "/user/profile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("个人中心", -1)]))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            divided: "",
            command: "logout"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("span", null, "退出登录", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_unref(state).user.nickName), 1), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_caret_bottom)]),
          _: 1
        })])]),
        _: 1
      })])])])]);
    };
  }
};